"use client";

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopTangsel: ReactNode = (
  <>
    <div className="text-xl font-bold mb-2">Mengapa Sewa Laptop Tangerang Selatan Adalah Langkah Cerdas?</div>

    <div className="text-lg font-semibold mb-2">
      Laptop Siap Kerja Tanpa Kompromi: Khusus Wilayah Tangerang Selatan & Sekitarnya
    </div>

    <p className="mb-4">
      Di balik gegap gempita kota mandiri seperti BSD, Serpong, dan Pamulang, ada kebutuhan nyata: laptop berkualitas yang bisa langsung digunakan tanpa ribet.
      Kamu sedang hadapi proyek dadakan, tim hybrid, atau tender instansi? Maka <strong>sewa laptop Tangerang Selatan</strong> hadir sebagai solusi kerja tanpa jeda.
    </p>

    <ul className="space-y-4 mb-6">
      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Area Layanan Meluas, Pengiriman Kilat</div>
        <p className="text-sm">
          Bukan hanya BSD dan Bintaro. Layanan <strong>sewa laptop Tangerang Selatan</strong> ini menjangkau seluruh titik potensial seperti Ciputat, Setu, hingga Pondok Aren.
          Begitu booking, unit segera meluncur. Bukan hari esok. Hari ini juga—selama unit ready.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Laptop Sudah Siap Pakai, Tanpa Setup²</div>
        <p className="text-sm">
          Gak ada waktu setting? Kamu gak sendiri. Itulah kenapa setiap <strong>laptop sewaan di Tangerang Selatan</strong> dikirim dengan OS & software lengkap.
          Bahkan bisa request custom—mau Adobe, AutoCAD, Office full—semua bisa. Plug & play.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Harga Jelas, Bisa Disesuaikan</div>
        <p className="text-sm">
          Kami memahami bahwa anggaran tiap bisnis berbeda. Oleh karena itu, <strong>harga sewa laptop Tangerang Selatan</strong> fleksibel.
          Mau harian, mingguan, atau bulanan? Bisa. Mau laptop standar, gaming, sampai workstation? Tersedia. Diskusi dulu, baru tentukan.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Unit Terawat & Bergaransi</div>
        <p className="text-sm">
          Jangan khawatir soal performa. Setiap unit dalam layanan <strong>sewa laptop Tangerang Selatan</strong> dicek berkala. Ada kendala? Kami tukar unitnya.
          Tidak perlu alasan panjang, tidak perlu prosedur berlapis. Fokus kamu tetap ke kerja, bukan troubleshooting.
        </p>
      </li>

      <li className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <div className="font-semibold text-lg mb-2">Konsultasi Gratis Sebelum Sewa</div>
        <p className="text-sm">
          Belum tahu butuh laptop seperti apa? Tenang. Tim kami siap bantu sesuaikan <strong>tipe laptop</strong> sesuai project-mu.
          Butuh RAM besar, SSD, layar besar, atau GPU khusus? Cukup sampaikan kebutuhan, kami siapkan rekomendasi.
        </p>
      </li>
    </ul>

    <div className="text-xl font-bold mb-3">Dukungan Teknis & Maintenance Berlapis</div>
    <p className="mb-4">
      Selama masa <strong>sewa laptop di Tangerang Selatan</strong>, teknisi kami rutin melakukan pengecekan remote. Ada update sistem, kami bantu.
      Bahkan jika ada crash sistem, teknisi siap datang langsung (on-site). Dukungan total, bukan sekadar janji.
    </p>

    <div className="text-xl font-bold mb-3">Durasi Fleksibel, Sesuai Irama Project-mu</div>
    <p className="mb-4">
      Kerja mingguan? Event 3 hari? Atau project 3 bulan? <strong>Sewa laptop Tangerang Selatan</strong> bisa disesuaikan.
      Bahkan bisa scaling hingga ratusan unit jika dibutuhkan untuk tender, instansi, atau event besar.
    </p>

    <div className="text-xl font-bold mb-3">Brand & Spek Lengkap: Dari Ekonomis Hingga Flagship</div>
    <p className="mb-4">
      Tak hanya soal jumlah. Kami juga punya variasi brand ternama: <strong>HP, Lenovo, Asus, Acer, Dell</strong>, hingga MacBook.
      Dari spek entry level untuk kebutuhan administrasi, sampai spesifikasi tinggi untuk editing video dan render desain. <strong>Sewa laptop Tangerang Selatan</strong> kini bukan sekadar opsi, tapi standar efisiensi kerja modern.
    </p>

    <div className="text-xl font-bold mb-3">Pengambilan Fleksibel: Diantar atau Ambil Sendiri</div>
    <p className="mb-4">
      Kamu bisa pilih: ambil langsung ke tempat kami, atau kami antar. Bahkan bisa dijemput kembali setelah masa sewa selesai.
      Cocok untuk kamu yang menghargai waktu dan ingin efisiensi maksimal.
    </p>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Laptop" />
  </>
);

export default laptopTangsel;